export const ArrowUpIcon = () => {
  return (
    <svg
      width="12"
      height="9"
      viewBox="0 0 12 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.91836 0.472656L11.5123 8.49241H0.324377L5.91836 0.472656Z"
        fill="#4FBA80"
      />
    </svg>
  );
};